import React, { Component } from 'react';
import App from '../components/App';

class AppCon extends Component {
  render() {
    return (
      <div>
        <App />
      </div>
    );
  }
}

export default AppCon;



// WEBPACK FOOTER //
// ./src/container/app-container.js